import { getGatewayTransport } from '~/apis/gatewayTransport'

import {
  ASSET_SCHEDULE_ENDPOINTS,
  createAssetScheduleTransport,
  createScheduleApi,
} from '@mangovoice/schedule'

export {
  normalizeAssetSchedule,
  normalizeAssetScheduleEvent,
  normalizeAssetScheduleEventRequest,
  normalizeAssetSchedulePayload,
} from '@mangovoice/schedule'

export const scheduleApi = createScheduleApi(
  createAssetScheduleTransport(getGatewayTransport()),
  ASSET_SCHEDULE_ENDPOINTS,
)
export const useScheduleApi = () => scheduleApi
